import Vue from 'vue'
import VueRouter from 'vue-router'

import Admin from '@/components/admin/admin'
import Categorias from '@/components/categorias/categorias'
import Colaboradores from '@/components/colaboradores/colaboradores'
import ColaboradorSubcategoria from '@/components/colaboradorSubcategoria/colaboradorSubcategoria'
import Configs from '@/components/configs/configs'
import Home from '@/components/home/home'
import ConfirmaJobs from '@/components/jobs/confirmaJobs'
import FinalizaJobs from '@/components/jobs/finalizaJobs'
import Jobs from '@/components/jobs/jobs'
import MeusJobs from '@/components/jobs/meusJobs'
import PagarJobs from '@/components/jobs/pagamentoJobs'
import ValidaJobs from '@/components/jobs/validaJobs'
import Login from '@/components/login/auth'
import Subcategorias from '@/components/subcategorias/subcategorias'
import TipoServico from '@/components/tipoServico/tipoServico'
import Extrato from '@/components/financeiro/extrato'
import ExtratoEmpresa from '@/components/financeiro/extratoEmpresa'


Vue.use(VueRouter)

const routes = [{
  name: 'home',
  path: '/',
  component: Home
},{
  name: 'login',
  path: '/login',
  component: Login
},{
  name: 'configs',
  path: '/configs',
  component: Configs
},{
  name: 'categorias',
  path: '/categorias',
  component: Categorias
},{
  name: 'subcategorias',
  path: '/subcategorias',
  component: Subcategorias
},{
  name: 'tipoServico',
  path: '/tipoServico',
  component: TipoServico
},{
  name: 'colaboradores',
  path: '/colaboradores',
  component: Colaboradores
},{
  name: 'colaboradorSubcategoria',
  path: '/colaboradorSubcategoria',
  component: ColaboradorSubcategoria
},{
  name: 'jobs',
  path: '/jobs',
  component: Jobs
},{
  name: 'meusJobs',
  path: '/meusJobs',
  component: MeusJobs
},{
  name: 'validaJobs',
  path: '/validaJobs',
  component: ValidaJobs
},{
  name: 'confirmaJobs',
  path: '/confirmaJobs',
  component: ConfirmaJobs
},{
  name: 'finalizaJobs',
  path: '/finalizaJobs',
  component: FinalizaJobs
},{
  name: 'pagarJobs',
  path: '/pagarJobs',
  component: PagarJobs
},{
  name: 'admin',
  path: '/admin',
  component: Admin
},{
  name: 'extrato',
  path: '/extrato',
  component: Extrato
},{
  name: 'extratoEmpresa',
  path: '/extratoEmpresa',
  component: ExtratoEmpresa
}
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router